import type { FallbackProps } from "react-error-boundary"

import { Button } from "@/components/ui/button"

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  // No futuro, você pode adicionar um serviço de log de erros aqui (Sentry, LogRocket, etc.)
  // console.error(error)

  return (
    <div
      className="flex h-screen w-screen flex-col items-center justify-center gap-6"
      role="alert"
    >
      <h1 className="text-4xl font-bold text-destructive">
        Oops! Algo deu errado.
      </h1>
      <p className="text-lg">Estamos trabalhando para corrigir o problema.</p>
      <Button onClick={resetErrorBoundary} variant="outline" className="mt-4">
        Tentar novamente
      </Button>
    </div>
  )
}